import React from "react";

export const Auth0Context = React.createContext(null);
export const useAuth0: () => any = () => React.useContext(Auth0Context);